<template>
  <div class="coverage">
    <section class="header-image">
      <div class="header-image-overlay"></div>
      <b-container>
        <b-row>
          <b-col lg="7">
            <h1>{{ $t('message.coverage.title_header') }}</h1>
            <p class="lead">{{ $t('message.coverage.subtitle') }}</p>
          </b-col>
          <b-col lg="5">
            <div class="header-breadcrumb">
              <router-link class="link-alt" :to="{ name: $i18n.locale + '_home' }">{{ $t('message.home.title') }}</router-link>
              • <span class="text-muted">{{ $t('message.coverage.title') }}</span>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="section bg-black-syntelix text-white text-center">
      <div class="container"><h2 class="text-orange-syntelix">{{ $t('message.coverage.our_scope.title') }}</h2>
        <hr class="hr-gradient-orange">
        <p class="lead">
          {{ $t('message.coverage.our_scope.paragraph') }}
        </p>
      </div>
    </section>

    <section class="section bg-gray-alt d-none d-sm-block">
      <b-container>
          <div id="world-map" style="width: 100%; height: 510px"></div>
      </b-container>
    </section>

    <section class="section">
      <b-container>
        <h2 class="text-center">{{ $t('message.coverage.coverage_by_country') }}</h2>
        <hr class="hr-gradient">
        <ul class="country-list list-unstyled">
          <li v-for="country in orderedCountries" :key="country.slug">
            <router-link :to="{ name: $i18n.locale + '_' + 'vsat_internet_satellite', params: { country_slug: country.slug} }">{{ country.name }}</router-link>
          </li>
        </ul>
      </b-container>
    </section>

    <QuickContact></QuickContact>
  </div>
</template>


<script>
  import QuickContact from "../components/QuickContact";
  const $ = require('jquery')
  window.jQuery = $
  require('jvectormap')
  require('@/assets/js/jquery-jvectormap-world-mill.js')
  require('jvectormap/jquery-jvectormap.css')

  import '../scss/coverage/coverage.scss'
  import countries from '@/coverage.json'

  export default {
    name: 'coverage',
    components: {QuickContact},
    metaInfo () {
      return  {
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        title: this.$t('meta.coverage.title'),
        link: [
          { rel: 'canonical', href: 'https://www.syntelix.net' + this.$route.path.replace(/\/$/, "") }
        ],
        meta: [
          {
            vmid: 'description',
            name: 'description',
            content: this.$t('meta.coverage.description')
          },
          {
            vmid: 'og:title',
            property: 'og:title',
            content: this.$t('meta.coverage.title')
          },
          {
            vmid: 'og:description',
            property: 'og:description',
            content: this.$t('meta.coverage.description')
          },
          {
            vmid: 'og:type',
            property: 'og:type',
            content: 'website'
          },
          {
            vmid: 'og:image',
            property: 'og:image',
            content: 'https://syntelix-website.s3-eu-west-1.amazonaws.com/og.jpg'
          },
          {
            vmid: 'og:url',
            property: 'og:url',
            content: 'https://www.syntelix.net' + this.$route.path
          }
        ],
        script: [{
          type: 'application/ld+json',
          json: {
            "@context": "http://schema.org",
            "@type": "Corporation",
            "legalName": "Syntelix Avances Tecnológicos S.L.",
            "brand": "Syntelix",
            "name": "Syntelix",
            "description": this.$t('meta.home.description'),
            "url": "https://www.syntelix.net",
            "email": "info@syntelix.net",
            "faxNumber": "(+34) 986 064 336",
            "logo": 'https://www.syntelix.net' + require('@/assets/images/logo.png'),
            "telephone": "(+34) 911 938 062",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "PTL Valladares Calle C, Nave C4",
              "addressLocality": "Vigo",
              "addressCountry": "España",
              "postalCode": "36314"
            }
          }
        }]
      }
    },

    data() {
      return {
        countries: countries,
      }
    },

    computed: {
      orderedCountries() {
        let countries = this.countries
        return countries[this.$i18n.locale].sort((a, b) => (a.name > b.name) ? 1 : -1);
      }
    },

    mounted() {
      this.initMap()
    },

    methods: {
      initMap() {
        const _this = this
        $('#world-map').vectorMap({
          map: 'world_mill',
          backgroundColor: '#FAFAFA',
          zoomOnScroll : false,
          zoomButtons : false,
          regionStyle: {
            initial: {
              fill: '#dddddd'
            },
            hover: {
              "fill"           : '#df5c16',
              "fill-opacity"   : 1,
              "stroke"         : '#ffffff',
              "stroke-width"   : 1,
              "stroke-opacity" : 0.5
            }
          },
          onRegionClick: function(event, code) {
            _this.mapSelect(code)
          }

        });
      },

      mapSelect(code) {
        let match = this.orderedCountries.filter(country => {
          return code === country.code
        })

        if (match.length > 0) {
          $('#world-map').vectorMap('get','mapObject').remove()
          this.$router.push({ name: this.$i18n.locale + '_' + 'vsat_internet_satellite', params: { country_slug: match[0].slug} })
        }
      }
    }
  }
</script>
